import { createSlice } from '@reduxjs/toolkit';

const loadingSlice = createSlice({
  name: 'loading',
  initialState: {
    global: false,
  },
  reducers: {
    showLoading: (state) => {
      state.global = true;
    },
    hideLoading: (state) => {
      state.global = false;
    },
  },
});

export const { showLoading, hideLoading } = loadingSlice.actions;
export default loadingSlice.reducer;